import gql from "graphql-tag";
import { productClassFragment } from "../fragments/productClass";

export default gql`
  mutation addProductClassMutation($input: AddProductClassInput!) {
    addProductClass(input: $input) {
      productClass {
        ...ProductClass
      }
    }
  }
  ${productClassFragment}
`;
